<template lang="pug">
  #GroupPush
    appHeader(
      :hasBackTool="true",
      targetRouterName="sa-items-list-index"
    )
    router-view.content-body-hasFooter(
      style="padding-bottom: 90px;"
    )
    appSaFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSaFooter from '@/components/partials/AppSaFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'GroupPushComponent',
  components: {
    appHeader,
    appSaFooter
  }
};
</script>
